const credit = () => {
    console.info("%c Développement : Aurélien Chappard - Deefuse %c ⟹ https://www.deefuse.fr", "font-family: Gill Sans, sans-serif;font-size:16px; background:#000; color:#38d430", "background:none");
}
export {credit};
